<template>
  <el-card v-loading="loading" :body-style="{padding: 0}" :shadow="shadow">
    <div class="container">
      <div class="title">
        <slot name="title"></slot>
      </div>
      <div class="value">
        <slot name="value"></slot>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'DashboardHero',
  props: {
    loading: { type: Boolean, default: false },
    shadow: { type: String, default: '' }
  }
}
</script>

<style scoped>
.container {
  display: inline-grid;
  width: 100%;
  grid-template-columns: [first] 50% [second] 50%;
}
.container div {
  padding: 0.5rem 0.75rem;
}
.title {
  color: #009aca;
}
.value {
  background: linear-gradient(35deg, #009aca, #0c3da7);
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/DashboardHero.vue